import api from "../utils/api";
import firestore from "../firebase/firestore";

export const getFares = (fares) => api.get("/fares/" + fares);

export const addFareFb = (uid, fare) => {
  fare.updated_at = new Date();
  fare.created_at = new Date();
  try {
    if (uid) {
      const ref = firestore.collection("fares");
      return ref.doc(uid).set(fare);
    } else {
      const ref = firestore.collection("fares");
      return ref.add(fare);
    }
  } catch (err) {
    console.error("Erro ao adicionar tarifa", err);
  }
};

export const updateFareFb = async (id, fare) => {
  const ref = firestore.doc(`fares/${id}`);
  fare.updated_at = new Date();
  return await ref
    .update(fare)
    .then(() => {
      console.log("Tarifa atualizada com sucesso");
      return ref.get();
    })
    .catch((err) => {
      console.error("Erro ao atualizar tarifa", err);
      return null;
    });
};
